<template>
  <div

    data-aos="fade"
    data-aos-duration="1000"
    data-aos-easing="ease-in-out"
    data-aos-once="true"
  >
  <header class="dispo_title">
    <MainTitle
      :title="$t('res.mainTitle')"
      :subtitle="$t('res.subTitle')"
      background="title_blue"
    ></MainTitle>
  </header>

  
<!-- FAQ -->
  <div
    class="faq_section"
    data-aos="fade"
    data-aos-duration="1000"
    data-aos-easing="ease-in-out"
    data-aos-once="true"
  >
 
  <p> {{ $t("res.description") }}<a href="tel:+33123456789">{{$t("res.number")}} </a>
    <a href="mailto:raymonde.tapparel@gmail.com">raymonde.tapparel@gmail.com</a>
      </p>
       <p>
    </p>


    <ul class="faq_list">
      <li v-for="(faq, index) in faqs" :key="index" class="faq_item">
        <button class="faq_question" @click="toggleFaq(index)">
          <span class="arrow" :class="{ open: faq.open }">▼</span>
          {{ faq.question }}
        </button>
        <p v-if="faq.open" v-html="faq.answer" class="faq_answer"></p>
      </li>
    </ul>
  </div>

  <!-- CALENDAR -->
  <div
    class="selector"
    data-aos="fade"
    data-aos-duration="1000"
    data-aos-easing="ease-in-out"
    data-aos-once="true"
  >
    <label for="month" class="selector_label">{{ $t("res.periode") }}</label>
    <input
    class="selector_input"
      type="month"
      id="month"
      v-model="selectedMonth"
      @change="goToSelectedMonth"
    />
  </div>

  <div
    class="availability-wrapper"
    data-aos="fade"
    data-aos-duration="1000"
    data-aos-easing="ease-in-out"
    data-aos-once="true"
  >
    <div class="calendar_container">
      <FullCalendar ref="fullCalendar" :options="calendarOptions" />
    </div>
  </div>
  </div>
</template>

<script>
import "vue-cal/dist/vuecal.css";
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import MainTitle from "@/components/MainTitle.vue";
import fr from "@/locales/fr.json";
import en from "@/locales/en.json";
import de from  "@/locales/de.json";
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { onMounted } from "vue";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase.js";

export default {
  components: { FullCalendar, MainTitle },

 setup() {
  //FAQ
    const { locale } = useI18n();

 const faqs = ref([]);
function loadFaqs() {
  const map = {
    fr: fr.res.faqs,
    en: en.res.faqs,
    de: de.res.faqs
  };
  const list = map[locale.value] || fr.res.faqs;
  faqs.value = list.map(f => ({ ...f, open: false }));
}

   // ✅ Charger au démarrage
    loadFaqs();


     // ✅ Recharger quand la langue change
    watch(locale, loadFaqs);

 function toggleFaq(index) {
      faqs.value[index].open = !faqs.value[index].open;
    }
// Calendrier
    const selectedMonth = ref("");
    const calendarRef = ref(null);

    const calendarOptions = ref({
      plugins: [dayGridPlugin],
      initialView: "dayGridMonth",
      locale: "fr",
      events: [],
      height: "auto",
    });

    // Référence à la collection Firestore
    const reservationsRef = collection(db, "reservations");

    // Récupérer les réservations en temps réel
   onMounted(() => {
 // Set mois actuel automatiquement
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      selectedMonth.value = `${year}-${month}`;

       // Charger le mois courant dans le calendrier
      const calApi = calendarRef.value?.getApi();
      if (calApi) calApi.gotoDate(today);

    
  onSnapshot(reservationsRef, snapshot => {
 const events = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
    // Transformer start/end en Date
      calendarOptions.value.events = events.map(r => ({
          title: r.title || "Réservé",
          start: r.start.toDate(),
          end: r.end ? r.end.toDate() : r.start.toDate(),
          allDay: true,
          color: "#A0DBF1",
      }));
  });
});
      

return { faqs, toggleFaq, calendarOptions, selectedMonth, calendarRef };
 },

  methods: {
   
    goToSelectedMonth() {
      const calendarApi = this.$refs.fullCalendar.getApi();
      const date = new Date(`${this.selectedMonth}-01`);
      calendarApi.gotoDate(date);
    },
  },
};
</script>
<style lang="scss">
@import "../assets/styles/_variables.scss";

.calendar_info {
  background-color: #f9fbff;
  border-left: 4px solid $third-color;
  padding: 1.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  font-size: 0.95rem;
  line-height: 1.6;
  color: #333;
  max-width: 75%;
  margin: 0 auto;


  a {
    color: $third-color;
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }

  strong {
    font-size: 1.1rem;
    display: block;
    margin-bottom: 0.5rem;
    color: #222;
  }

  em {
    font-style: italic;
    color: #388e3c;
  }
}
.calendar_container {
  margin: 2rem auto;
  background: white;
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}
/* Toolbar FullCalendar */
.fc .fc-toolbar-title {
  font-size: 1.4rem !important;
  font-weight: 600;
}

.fc .fc-button {
  border-radius: 8px !important;
  padding: 0.4rem 0.8rem !important;
  border: none !important;
  background: $third-color !important;
  color: white !important;
  transition: 0.2s ease;
}

.fc .fc-button:hover {
  filter: brightness(1.1);
}

.fc-daygrid-day {
  padding: 6px !important;
}

.fc-event {
  border-radius: 6px !important;
  padding: 2px 4px !important;
  font-size: 0.75rem !important;
}
.dispo_title { max-width: 75%; margin: $spacing-extralarge auto; margin-bottom: 0rem; }

.selector {
  max-width: 75%;
  margin: $spacing-extralarge auto;
}
.selector_input{
   padding: 0.4rem 0.6rem;
  font-size: 1rem;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #fff;
  transition: 0.2s ease;;
}
.selector_input:focus {
  border-color: $third-color;
  box-shadow: 0 0 0 2px rgba(0, 129, 204, 0.25);
}
.faq_section {
  max-width: 75%;
  margin: 1rem auto;
}

.faq_list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.faq_item {
  margin-bottom: 0.3rem;
  border-bottom: 1px solid #ddd;
}

.faq_question {
  background: none;
  padding-left: 0rem;
  border: none;
  color: var(--mdb-body-color);
  font-size: 1rem;
  text-align: left;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
    box-shadow: 0 0.03125rem 0.0625rem rgba(0, 0, 0, 0);
 
   &:hover {
      box-shadow: rgba(0, 0, 0, 0) 0rem 0rem 0rem 0rem;
      transform: translate3d(0, 0rem, 0);

    }

    &:focus {
      box-shadow: rgba(0, 0, 0, 0) 0.125rem 0.5rem 0.25rem -0.375rem;
    }

  .arrow {
    margin-right: 1rem;
    transition: transform 0.3s ease;
    &.open {
      transform: rotate(180deg);
    }
  }
}

.faq_answer {
  font-size: 1rem;
  margin-top: 0.5rem;
  font-weight: normal;
  color: var(--mdb-body-color);
  line-height: 1.4;
}

.availability-wrapper {
  
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 2rem;
  margin: 2rem auto;
  max-width: 1200px;
  padding: 0 1rem;
}

.calendar_container,
.sidebar {
  flex: 1 1 45%;
  min-width: 300px;
}

@media (max-width: 768px) {

    
    .selector_input {
    width: 100%;
  }
  .titlecontainer {
    max-width: 90%;
  }
  .faq-section {
    max-width: 90%;
  }

  .fc .fc-daygrid-body-natural .fc-daygrid-day-events {
    margin-bottom: 0em;
  }
  .calendar_info{
    max-width: 95%;
    margin: 0 auto;
  }
}
</style>
